var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHandoverActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 3,
    width: 18,
    height: 18,
    rx: 9,
    fill: "#BEA5EF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 3,
    width: 18,
    height: 18,
    rx: 9,
    stroke: "#BEA5EF",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.2941 9.97483V10.2857H8.76471C8.21654 10.2857 7.94246 10.2857 7.72625 10.3727C7.43799 10.4887 7.20896 10.7112 7.08955 10.9912C7 11.2013 7 11.4675 7 12C7 12.5325 7 12.7987 7.08955 13.0088C7.20896 13.2888 7.43799 13.5113 7.72625 13.6273C7.94246 13.7143 8.21654 13.7143 8.76471 13.7143H12.2941V14.0251C12.2941 15.2153 12.2941 15.8103 12.6472 15.967C13.0004 16.1236 13.4225 15.7158 14.2668 14.9001L16.3631 12.8749C16.7877 12.4647 17 12.2595 17 12C17 11.7405 16.7877 11.5353 16.3631 11.1251L14.2668 9.09992C13.4225 8.28424 13.0004 7.87641 12.6472 8.03302C12.2941 8.18963 12.2941 8.7847 12.2941 9.97483Z",
    stroke: "#6929E2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHandoverActive);
export default __webpack_public_path__ + "static/media/handover_active.eb28d28958b97ca7387bb27f2a3e752b.svg";
export { ForwardRef as ReactComponent };